import React from "react";
import "./Mustread.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
//import "react-lazy-load-image-component/src/effects/blur.css";
import ImageConvertionDefault from "../../config";
export default class MustRead extends React.PureComponent {
  render() {
    let pagelist = this.props.dataFromParent;
    const _PagelistDataItemss = pagelist.map((item, count) => (
      <div className="news_widget_panel mustread" key={count}>
        <div className="n_w_p_head">
          <h2>
            <label>{item.Title}</label>
          </h2>
        </div>
        <div className="n_w_p_body">
          {item.Pages.map((item, i) => (
            <div className="news2_block" key={i}>
              <h3>
                <a href={item.Url}>{item.Title}</a>
              </h3>
              <div className="n2_b_box">
                <span className="n2_b_b_thumb">
                  <a href={item.Url}>
                    <LazyLoadImage
                      effect="blur"
                      src={ImageConvertionDefault(item.Image || item.Thumbnail, 220 , 180)}
                      alt={item.Title} title={item.Title}
                      width="100%"
                      height="auto"
                    />
                  </a>
                </span>
                <span className="n2_b_b_cont">
                  {item.Description.slice(0, 85) + "..."}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    ));
    return <>{_PagelistDataItemss}</>;
  }
}
